import React from "react";
import GitHubCalendar from "react-github-calendar";
import ReactTooltip from "react-tooltip";
import { Row, Col } from "react-bootstrap";

function Github() {
  const username = "Pranav-1100";

  return (
    <>
      <h1 className="project-heading" style={{ paddingTop: "40px", paddingBottom: "20px" }}>
        GitHub <strong className="purple">Statistics</strong>
      </h1>

      {/* GitHub Stats Cards */}
      <Row style={{ justifyContent: "center", paddingBottom: "30px" }}>
        <Col md={6} style={{ paddingBottom: "20px" }}>
          <img
            src={`https://github-readme-stats-one-bice.vercel.app/api?username=${username}&show_icons=true&theme=radical&hide_border=true&bg_color=0d1117&title_color=c770f0&icon_color=c770f0&text_color=ffffff&count_private=true&include_all_commits=true`}
            alt="GitHub Stats"
            style={{ width: "100%", maxWidth: "500px" }}
          />
        </Col>
        <Col md={6} style={{ paddingBottom: "20px" }}>
          <img
            src={`https://github-readme-streak-stats.herokuapp.com/?user=${username}&theme=radical&hide_border=true&background=0d1117&ring=c770f0&fire=c770f0&currStreakLabel=c770f0`}
            alt="GitHub Streak"
            style={{ width: "100%", maxWidth: "500px" }}
          />
        </Col>
      </Row>

      {/* Top Languages Card */}
      <Row style={{ justifyContent: "center", paddingBottom: "30px" }}>
        <Col md={6}>
          <img
            src={`https://github-readme-stats-one-bice.vercel.app/api/top-langs/?username=${username}&layout=compact&theme=radical&hide_border=true&bg_color=0d1117&title_color=c770f0&text_color=ffffff&langs_count=8`}
            alt="Top Languages"
            style={{ width: "100%", maxWidth: "500px" }}
          />
        </Col>
      </Row>

      {/* GitHub Contribution Calendar */}
      <Row style={{ justifyContent: "center", paddingBottom: "10px", paddingTop: "20px", position: "relative", zIndex: 1 }}>
        <h2 className="project-heading" style={{ paddingBottom: "20px", fontSize: "1.8em" }}>
          Daily <strong className="purple">Contribution</strong> Activity
        </h2>
        <GitHubCalendar
          username={username}
          blockSize={15}
          blockMargin={5}
          color="#c084f5"
          fontSize={16}
          tooltips={true}
        >
          <ReactTooltip delayShow={50} html className="custom-tooltip" />
        </GitHubCalendar>
      </Row>
    </>
  );
}

export default Github;
